import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { COLORES } from '../../../../config/colores'

function ProyectadosPool (props) {
  const { fecha, cereal, simulacionesPersistidas, cuposProyectados } = props
  const [cantidad, setCantidad] = useState(0)

  useEffect(() => {
    const proyecciones = simulacionesPersistidas && simulacionesPersistidas.filter(s => s.exportador === 'POOL' && s.fecha === fecha && s.cereal === cereal)
    const cantidad = (proyecciones[0] && proyecciones[0].cuposSimulados) || 0

    const proyeccionExportadores = simulacionesPersistidas && simulacionesPersistidas.filter(s => s.exportador !== 'POOL' && s.fecha === fecha && s.cereal === cereal)
    let cantProyeccionExp = 0

    const proyeccionExistente = cuposProyectados && cuposProyectados.filter(s => s.fecha === fecha && s.cereal.trim() === cereal)
    let cantProyecciones = 0

    proyeccionExportadores && proyeccionExportadores.map((p) => {
      return (cantProyeccionExp += p.cuposSimulados)
    })

    proyeccionExistente && proyeccionExistente.map((p) => {
      return (cantProyecciones += p.cantidadAsignada)
    })

    setCantidad(cantidad - cantProyeccionExp - cantProyecciones)
  }, [simulacionesPersistidas, fecha, setCantidad, cereal, cuposProyectados])

  return (
    <p style={{ color: COLORES.grey.mediumDark, margin: 0, padding: 0 }}> {cantidad > 0 && cantidad } </p>
  )
}

const mapStateToProps = (state) => ({
  simulacionesPersistidas: state.stock.simulacionesPersistidas,
  cuposProyectados: state.stock.cuposProyectados
})

const withRedux = connect(mapStateToProps, null)
export default withRedux(ProyectadosPool)
